import { FC } from 'react';
import { Text } from '@doda/io-react/common';
import { TopicJob } from '@doda/pc/src/pages/DodaFront/View/FeaturedJobList/types';
import styles from './index.module.scss';
import { getPublishingPeriod } from './components/logic/getPublishingPeriod';

/**
 * TopicJobContents Props
 */
interface Props {
  /** 表示するトピック求人情報 */
  topicJob: TopicJob;
}

/**
 * TopicJobContentsコンポーネントは、トピック求人情報を表示
 *
 * @param {Props} props - コンポーネントのプロパティ
 * @param {TopicJob} props.topicJob - 表示するトピック求人情報
 * @returns {JSX.Element} トピック求人情報を表示するコンポーネント
 */
export const TopicJobContents: FC<Props> = ({ topicJob }) => {
  const startDate = topicJob.publishingSchedulePeriodStartDate;
  const endDate = topicJob.publishingSchedulePeriodEndDate;

  const publishingPeriodText = getPublishingPeriod({ startDate, endDate });

  return (
    <>
      {topicJob.message && (
        <Text
          size="12"
          color="gray"
          className={styles.featuredJobList__message}
        >
          {topicJob.message}
        </Text>
      )}
      {publishingPeriodText && (
        <Text
          size="14--articlePC"
          className={styles.featuredJobList__publishingPeriod}
        >
          {publishingPeriodText}
        </Text>
      )}
      {topicJob.imageHTML && (
        <div
          className={styles.featuredJobList__image}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: topicJob.imageHTML }}
        />
      )}
    </>
  );
};
